import React from 'react';
import _ from 'underscore';
import { Formik, Form, Field, FieldArray } from 'formik';
import { Button, Grid, Divider, Segment, Header, Dimmer, Loader } from 'semantic-ui-react';
import moment from 'moment'

import FormsInputsText from '../../../forms/inputs/text/forms_inputs_text';
import CommonUtility from '../../../../utils/CommonUtility';
import { USER_TYPE, USER_ROLES } from '../../../../constants';


class UserFormStudent extends React.Component {

    render() {

        const { user, company } = this.props;
        const isAdminOperation = CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, this.props.admin) && CommonUtility.haveRoles([USER_ROLES.ADMIN_OPERATION], this.props.admin);

        return (
            <Formik
                initialValues={{
                    uuid: user.uuid,
                    studentFullBankAccountNo: user.studentFullBankAccountNo || '',
                    studentEmail: user.studentEmail || '',
                    studentTel: user.studentTel || '',
                    studentCareerCode: user.studentCareerCode || '',
                    studentMaritalStatus: user.studentMaritalStatus || '',
                    studentID: user.studentID || '',
                    studentNationality: user.studentNationality || '',
                    singaporeCitizenshipstatus: user.singaporeCitizenshipstatus || '',
                    nsMenIndicator: user.nsMenIndicator || '',
                }}
                validateOnChange={false}
                validateOnBlur={false}
                // validationSchema={OutpatientValidationSchema}
                onSubmit={this.props.onSubmit}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue
                }) => {

                    // Show loading UI
                    if(isSubmitting){
                        return ( <Dimmer active inverted><Loader>Loading</Loader></Dimmer>)
                    }

                    return (
                        <Segment>
                            <Form>
                                <Grid container columns={2}>
                                    <Grid.Column width={16}>
                                        <Divider horizontal style={{ margin: "13px 0 30px 0" }}> <Header as='h3'>Student Information</Header></Divider>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="studentFullBankAccountNo" label="Student Full Bank Account No" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="studentEmail" label="Student Email" component={FormsInputsText} secondaryLabel="" type="email" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="studentTel" label="Student Tel" component={FormsInputsText} secondaryLabel="" type="tel" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="studentCareerCode" label="Student Career Code" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="studentMaritalStatus" label="Student Marital Status" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="studentID" label="Student ID" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="studentNationality" label="Student Nationality" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="singaporeCitizenshipstatus" label="Singapore Citizenship Status" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="nsMenIndicator" label="Ns Men Indicator" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    {isAdminOperation &&
                                        <Grid.Column width={16}>
                                            <Button type="submit" primary fluid size="big" >{this.props.submitText}</Button>
                                        </Grid.Column>
                                    }
                                    <Grid.Column width={16}>
                                        { this.props.renderSubmitResult instanceof Function && this.props.renderSubmitResult() }
                                    </Grid.Column>
                                </Grid>
                            </Form>
                        </Segment>
                    )
                }}
            >

            </Formik>
        )
    }

}

UserFormStudent.defaultProps = {
    user: {},
    company: {},
    admin: {},
    onSubmit: undefined,
    showDetail: true,
    renderSubmitResult: undefined,
    submitText: "Save"
}

export default UserFormStudent;

